/**
 * localStorage存储的信息
 * @file   localStorage
 * @author author-name(lhb 1301465186@qq.com)
 */
const TokenKey = 'Deer-Admin-Token'
const RefreshKey = 'Deer-Refresh-Token'
const ExpiresKey = 'Deer-Refresh-Expires'
const AuthTimeKey = 'Deer-Auth-Time'
const TenantId = 'Deer-Tenant-Id'
const TenantName = 'Deer-Tenant-Name'
const UserName = 'Deer-User-Name'
const Password = 'Deer-User-Password'
const Report = 'Deer-Report-List'
// TODO: 常用报表无接口,暂且放进缓存
import store from '@/base/store'

/**
 * 获取token
 *
 * @export
 * @returns
 */
export function getToken() {
  return store.get(TokenKey)
}

/**
 * 存储token
 *
 * @export
 * @param {*} token 存储的值
 * @returns
 */
export function setToken(token) {
  return store.set(TokenKey,token); 
}

/**
 * 清空token及store信息
 *
 * @export
 */
export function removeToken() {
  store.clear();
}

/**
 * 获取token刷新值
 *
 * @export
 * @returns
 */
export function getRefresh() {
  return store.get(RefreshKey)
}

/**
 * 存储的刷新token
 *
 * @export
 * @param {*} token 存储的值
 * @returns
 */
export function setRefresh(token) {
  return store.set(RefreshKey, token)
}

/**
 * 存储的刷新的时间
 *
 * @export
 * @returns
 */
export function setAuthTime() {
  return store.set(AuthTimeKey, Date.now())
}

/**
 * 获取刷新时间
 *
 * @export
 * @returns
 */
export function getAuthTime() {
  return parseInt(store.get(AuthTimeKey), 10)
}

/**
 * 存储时间间隔值
 *
 * @export
 * @param {*} time
 * @returns
 */
export function setExpires(time) {
  return store.set(ExpiresKey, time)
}

/**
 * 获取时间间隔值
 *
 * @export
 * @returns
 */
export function getExpires() {
  return store.get(ExpiresKey)
}

// 租户id
export function setTenantId(id) {
  return store.set(TenantId, id)
}

export function getTenantName() {
  return store.get(TenantName)
}

// 租户name
export function setTenantName(id) {
  return store.set(TenantName, id)
}

export function getTenantId() {
  return store.get(TenantId)
}

// 登录手机号
export function setUserName(v) {
  return store.set(UserName, v)
}

export function getUserName() {
  return store.get(UserName)
}

// 登录密码
export function setPassword(v) {
  return store.set(Password, v)
}

export function getPassword() {
  return store.get(Password)
}

// 常用报表
export function setReport(v) {
  return store.set(Report, v)
}

export function getReport() {
  return store.get(Report)
}

export function removeReport() {
  return store.remove(Report)
}